export default __webpack_public_path__ + "static/media/figuremap24.614da8d5.png";